import KeepMoreCompleteModal from './KeepMoreCompleteModal';
const meta = {
    title: 'Features/Inspections/ConflictsListing/KeepMoreCompleteModal',
    component: KeepMoreCompleteModal,
    args: {
        isOpen: true,
        isSubmitting: false,
        isLoading: false,
        hasError: false,
        summary: {
            groupsTotal: 4,
            groupsResolvableByCompleteness: 3,
            technicians: []
        },
        onClose: () => undefined,
        onConfirm: () => Promise.resolve()
    }
};
export default meta;
export const Default = {};
export const Loading = {
    args: { isLoading: true, summary: null }
};
export const LoadFailed = {
    args: { hasError: true, summary: null }
};
export const Submitting = {
    args: { isSubmitting: true }
};
export const NothingToResolve = {
    args: {
        summary: {
            groupsTotal: 2,
            groupsResolvableByCompleteness: 0,
            technicians: []
        }
    }
};
